var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"available-user-item"},[_c('BCXAvatar',{staticClass:"c-avatar",attrs:{"user-id":_vm.id,"size":26}}),_c('span',{staticClass:"bcx-truncated-text",attrs:{"title":_vm.fullname}},[_vm._v(_vm._s(_vm.fullname))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }